/**
 * Copyright (c) 2021-2026 Kognitos, Inc. All rights reserved.
 */

/**
 * UTF-8-safe base64 codec for text payloads exchanged through proto `bytes`
 * fields (e.g. an automation's `artifacts` map, which serializes to base64
 * strings in JSON). Plain `btoa`/`atob` only handle Latin-1, so anything with
 * accents, arrows, or non-ASCII punctuation would throw or corrupt.
 */

export function encodeTextToBase64(text: string): string {
  const bytes = new TextEncoder().encode(text);
  let binary = '';
  // Chunked to avoid call-stack limits with String.fromCharCode(...bytes).
  const CHUNK = 0x8000;
  for (let i = 0; i < bytes.length; i += CHUNK) {
    binary += String.fromCharCode(...bytes.subarray(i, i + CHUNK));
  }
  return btoa(binary);
}

export function decodeBase64ToText(base64: string): string {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new TextDecoder().decode(bytes);
}
